"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Pin = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 12,
  height: 12,
  viewBox: "0 0 12 12"
}, props), _react.default.createElement("path", {
  d: "M12 6.222L5.778 0l-.889.888.89.89-3.112 3.111L1.777 4l-.888.89 2.666 2.666L0 11.111.889 12l3.555-3.555 2.667 2.666.889-.888-.889-.89 3.111-3.11.89.888z",
  className: "fill"
}));

var _default = Pin;
exports.default = _default;